import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ISO_LANGUAGE_CODES, SupportedLanguage } from '@/i18n/constants'
import { formatNumber } from '@/lib/utils'

export const useFormatLocalizedNumber = (defaultOptions?: Intl.NumberFormatOptions) => {
  const { i18n } = useTranslation()
  const language = useMemo(() => ISO_LANGUAGE_CODES[i18n.language as SupportedLanguage], [i18n.language])

  const formatValue = useCallback(
    (value?: number | string | null, options?: Intl.NumberFormatOptions) => {
      if (value === null || Number.isNaN(value) || value === undefined) {
        return null
      }
      return formatNumber(value, { ...defaultOptions, ...options, language })
    },
    [defaultOptions, language]
  )
  return formatValue
}
